/**
 * 売上品目単価CSV関連
 */　
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/settings/sales_item_prices`

const setting_sales_item_price = {
  namespaced: true,
  actions: {
    /**
     * 売上品目単価CSV取得
     * @param commit
     * @param reference_date
     * @return {Promise<unknown>}
     */
    index ({ commit }, { reference_date, code, name, item_id, sales_item_type}) {
      let params = { 
        reference_date: reference_date, 
        code: code, 
        name: name, 
        item_id: item_id, 
        sales_item_type: sales_item_type
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data)
        })
      })
    },

    /**
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, {headers: {'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default setting_sales_item_price
